


























































































































import SubmitButton from "@/components/basic/buttons/SubmitButton.vue";
import NavigationButton from "@/components/basic/buttons/NavigationButton.vue";
import File from "@/components/basic/fields/File.vue";
import Vue from "vue";
import { Action } from "@/constants/ajax";
import { mapState } from "vuex";
import { SET_PROGRESS } from "@/constants/mutation-types";
import UploadError from "../UploadError.vue";
import HowToTakePicture from "@/components/HowToTakePicture.vue";
import SecurityPopup from "@/components/basic/SecurityPopup.vue";
import { UtilityHelper } from "@/helpers/UtilityHelper";
import { smartCapture, camera, gateway, fileSystem, view, result } from "@/libraries/websdk_templates";
import { translations } from "@/libraries/translations";
import DesktopUpload from "./DesktopUpload.vue";

export default Vue.extend({
  name: "MobileUpload",
  data() {
    return {
      documentType: null as DocumentType | null,
      action: null as null | Action,
      isPdfFile: false,
      showHowToTakePicture: true,
      gbgToken: "",
      clientId: "",
      info: "",
      showInfo: false,
      showLoader: true,
      isSecuringConnection: false,
      showHelp: false,
      manualAvailable: false,
      isPhotoUpload: false,
      isShowCamera: false,
      isShowWelcomeMessage: true,
      TRANSLATION_KEY: "steps.UploadDocumentFront",
      translationDictionary: {},
      gotCameraPermissions: false,
      noPermissions: null as null | boolean,
      helpAvailable: true,
      result: "",
      journeyEnd: false,
      sdkTranslations: translations.en,
      showCustomNotification: false,
      journeyId: "",
      isBadUpload: false,
      isBack: false,
      showRedError: false,
      availableCameras: [],
      ignoreFirstJourneyProgress: true,
      backendUrl: '',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.commit(SET_PROGRESS, 6);
    this.getTranslations();
    this.getToken();
    this.$store.state.isUploadDocumentStep = true;
    this.openHelp();
    this.handleAttemptsButton();
    this.handleShowHelp();
    this.checkCanvas();
  },

  methods: {
    checkCanvas() {
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      function checkCanvas() {
        const videoElement = document.querySelector("video");
        if (videoElement) {
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          if (context) {
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            const pixelData = context.getImageData(0, 0, canvas.width, canvas.height).data;
            const isBlank = pixelData.every(value => value === 0); // Check if all pixels are black
            if (isBlank) {
              console.warn("Camera feed is blank (all black frames).");
            } else {
              console.log("Camera feed contains data.");
            }
          }
        }
      }
      setInterval(checkCanvas, 1000);
    },

    getAvailableCameras() {
      navigator.mediaDevices
        .enumerateDevices()
        .then(devices => {
          //@ts-ignore
          this.availableCameras = devices.filter(device => device.kind === "videoinput");
        })
        .catch(error => {
          console.error("Błąd przy pobieraniu urządzeń:", error);
        });
    },

    getTranslations() {
      //@ts-ignore
      this.sdkTranslations = translations[UtilityHelper.getLocale()];
    },

    handleAttemptsButton() {
      const body = document.querySelector("body") as HTMLBodyElement;
      const eventHandler = (e: any) => {
        const target = e.target as HTMLElement;
        if (target.matches(".help-button-wrapper, .help-button-wrapper span, .help-button-wrapper p")) {
          //@ts-ignore
          document.querySelector(".notification-blue").style.display = "none";
        }
        if (target.matches(".control__switch, .control__switch *, .manual--mode--switch, .manual--mode--switch *")) {
          body.classList.add("hide-notification");
          const interval = setInterval(() => {
            if (document.querySelector(".notification-blue")) {
              //@ts-ignore
              document.querySelector(".notification-blue").style.display = "none";
              body.classList.remove("hide-notification");
              clearInterval(interval);
            }
          }, 1);
        }
      };
      if (body) {
        body.addEventListener("click", eventHandler);
      }
    },

    handleShowHelp() {
      const body = document.querySelector("body") as HTMLBodyElement;
      const eventHandler = (e: any) => {
        const target = e.target as HTMLElement;
        if (target.matches(".notification-photo-help, .notification-photo-help span, .notification-photo-help p")) {
          this.$store.state.showInstructionPopup = true;
          this.showHelp = false;
        }
      };
      if (body) {
        body.addEventListener("click", eventHandler);
      }
    },

    handleManual() {
      const manualSwitch = document.querySelector("body .manual--mode--switch");
      if (manualSwitch) {
        //@ts-ignore
        manualSwitch.querySelector("input").click();
        this.manualAvailable = true;
        this.showHelp = false;
      }
    },

    handleShowPopup() {
      this.$store.state.showInstructionPopup = true;
      this.showHelp = false;
    },

    showCameraSelection() {
      this.isShowCamera = true;
      this.showHelp = false;
      const div = document.querySelector("body .dark-inner-provider-container");
      if (div) {
        div.scroll({ top: 0, behavior: "smooth" });
      }
    },

    async notifyJourney(journeyId: string, journeyStatus: string) : Promise<any> {
      const ajaxService = this.$store.state.ajaxService;
      try {
        const data = await ajaxService.post(ajaxService.DOCUMENT_ROUTE + "notify-journey", {
          token: ajaxService.getToken(),
          journeyStatus: journeyStatus,
          journeyId: journeyId,
        });
        if(data.status === 'error') {
          this.$store.state.globalError = data.errors;
        }
      } catch (error) {
        this.$store.state.globalError = error;
      }

    },

    gbgSDK() {
      //@ts-ignore
      const onJourneyEventPro = (event, meta, state) => {
        switch (event) {
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.DISPLAY_STEP:
            if (state.inputProvider == "FILESYSTEM" && state.journey.currentResult == "Failed") {
              this.isBadUpload = true;
            } else {
              this.isBadUpload = false;
            }
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_STARTED:
            this.showLoader = true;
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_CANCEL:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_CLEAR:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_PROGRESS:
            if(!this.ignoreFirstJourneyProgress) {
              this.notifyJourney(this.journeyId, event);
            }
            this.ignoreFirstJourneyProgress = false;
            if (state.action == "IDENTITY:BACK") {
              this.isBack = true;
            } else {
              this.isBack = false;
            }
            // if (state.journey && typeof state.journey.journeyId !== "undefined") {
            //   this.notifyJourney(state.journey.journeyId, event);
            // }
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_START:
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.JOURNEY_END:
            this.$store.state.isGbg = false;
            this.$store.state.isUploadDocumentStep = false;
            this.$store.state.showLongDisclaimer = false;
            this.$store.state.isLocked = "active";
            setTimeout(() => {
              fetch(`${this.backendUrl}idscanenterprisesvc/journey/get?journeyId=${this.journeyId}`, {
                headers: { Authorization: this.gbgToken },
              })
                .then((response: any) => {
                  response.json().then((data: any) => {
                    this.$store.state.clientIdData = data.ProcessedDocuments;
                    this.$store.state.isSubheaderVisible = true;
                    const journeyStatus = data.HighLevelResult.toLowerCase();
                    this.$store.state.isLocked = "";

                    const params = new URLSearchParams(window.location.search);
                    if (params.get("mobile") === "true") {
                      //Hybrid
                      this.$router.push({ name: 'mobileReturnToDesktop'});
                    } else {
                      if (journeyStatus === "passed") {
                        this.$router.push({ name: "uploadSucceeded" });
                      } else {
                        this.$router.push({ name: "uploadFailed" });
                      }
                    }
                  });
                })
                .catch((err: any) => {
                  console.error(err);
                });
            }, 1000);
            this.notifyJourney(this.journeyId, event);
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_COMPLETE:
            this.showLoader = false;
            break;
          //@ts-ignore
          case GBG.Idscan.JourneyEvent.TRANSFER_FAILED:
            this.showLoader = false;
        }
      };

      const overrideTemplate = {
        smartCapture: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return smartCapture();
          },
        },
        camera: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return camera();
          },
        },
        gateway: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return gateway();
          },
        },
        filesystem: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return fileSystem();
          },
        },
        view: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return view();
          },
        },
        result: {
          type: "function",
          processor: "mustache",
          provider: function() {
            return result();
          },
        },
      };

      //@ts-ignore
      new window.GBG.Idscan.JourneyContainer({
        backendUrl: `${this.backendUrl}`,
        container: "#gbgContainer",
        token: this.gbgToken,
        JourneyId: `"${this.journeyId}"`,
        onJourneyEvent: onJourneyEventPro,
        journeyDefinitionId: "887fa09f-e942-4d11-b937-84e8e4263415",
        smartCapture: {
          autoStart: true,
          timeout: 5000,
          workerScriptUrl: process.env.BASE_URL+"idscan/ides-micro.5533c29dc09364ea7b8e.js",
          asmScriptUrl: "idesmicro_asm.js",
        },
        manualCapture: {
          enabled: true,
          timeout: 15,
        },
        dictionary: this.sdkTranslations,
        hideAutoCaptureHints: false,
        isVerboseLogEnabled: true,
        templates: overrideTemplate,
        additionalData: [
          {
            Name: "TMSClientId",
            Value: this.clientId,
          },
        ],
        assetsDirectory: process.env.BASE_URL+"assets",
      }).initialize();
    },

    async getToken(): Promise<any> {
      const ajaxService = this.$store.state.ajaxService;
      let retryCount = 0;
      const maxRetries = 4;
      const fetchToken = async () => {
        try {
          const data = await ajaxService.post(ajaxService.DOCUMENT_ROUTE + "get-idscan-token", {
            token: ajaxService.getToken(),
          });
          if (data.status === "success") {
            this.gbgToken = data.gbgToken;
            this.journeyId = data.journeyId;
            this.clientId = data.clientId;
            this.backendUrl = data.backendUrl;
            this.checkCameraPermissions();
            return data; // Success, return the data
          } else {
            if (retryCount < maxRetries) {
              retryCount++;
              setTimeout(fetchToken, 3000); // Retry after 3 seconds
            } else {
              // Handle non-success status
              // this.$store.state.globalError = "Failed to get token: " + data.errors;
              this.$router.push({ name: "uploadException" });
            }

          }
        } catch (error) {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(fetchToken, 3000); // Retry after 3 seconds
          } else {
            // this.$store.state.globalError = error;
            this.$router.push({ name: "uploadException" });
          }

        }
      }

      await fetchToken();
    },

    handlePopup(): void {
      this.$store.state.isPhotoInstructionsOpen = !this.$store.state.isPhotoInstructionsOpen;
    },

    handleHowToTakePicture() {
      this.isSecuringConnection = true;
      this.$store.state.analyticsService.sendStepEvent("howToTakePicture");
      this.showHowToTakePicture = !this.showHowToTakePicture;
      this.$store.state.isGbg = true;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.isSecuringConnection = false;
      }, 3000);
    },

    openHelp() {
      const helpButton = document.querySelector("body");
      const eventHandler = (e: any) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains("show-help-button")) {
          this.showHelp = true;
        }
      };
      if (helpButton) {
        helpButton.addEventListener("click", eventHandler, { passive: true });
      }
    },

    closeHelp() {
      this.showHelp = false;
    },

    handleSecurity() {
      this.$store.state.showSecurityPopup = true;
      this.showHelp = false;
    },

    handleUpload() {
      const photoUploadButton = document.querySelector("body .upload-photos-button") as HTMLElement | null;

      if (photoUploadButton) {
        photoUploadButton.click();
        this.showCustomNotification = false;
        this.showHelp = false;
        this.$store.state.isGbg = false;
        this.isPhotoUpload = true;
      }
    },

    async checkCameraPermissions() {
      const isAndroid = /android/i.test(navigator.userAgent);
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        stream.getTracks().forEach(track => track.stop());
        this.gotCameraPermissions = true;
        this.showCustomNotification = true;
        await this.getAvailableCameras();

        if (isAndroid) {
          const rearCamera = this.availableCameras.find(device => {
            //@ts-ignore
            const label = device.label.toLowerCase();
            return label.includes("back") || label.includes("rear") || label.includes("environment");
          });
          if (rearCamera) {
            //@ts-ignore
            const constraints = { video: { deviceId: { exact: rearCamera.deviceId } } };
            const rearStream = await navigator.mediaDevices.getUserMedia(constraints);
            rearStream.getTracks().forEach(track => track.stop());
          }
        }
        this.isShowWelcomeMessage = false;
        await this.$nextTick();
        this.gbgSDK(); 
      } catch (error) {
        console.error("Error in checkCameraPermissions:", error);
        this.noPermissions = true;
        this.isShowWelcomeMessage = false;
        this.showCustomNotification = false;
      }
    },

    handleShowPopupNoCamera() {
      this.$store.state.showInstructions = true;
    },
  },
  computed: {
    ...mapState({
      isSkipAllowed: (state: any) => state.formData.isSkipAllowed,
      isPhotoInstructionsOpen: (state: any) => state.isPhotoInstructionsOpen,
      hasError: (state: any) => state.errors,
      isMobile: (state: any) => state.isDetectedMobileDevice,
      showPopup: (state: any) => state.showInstructionPopup,
      showInstructions: (state: any) => state.showInstructions,
      securityPopup: (state: any) => state.showSecurityPopup,
      isGbg: (state: any) => state.isGbg,
      isUploadDocumentStep: (state: any) => state.isUploadDocumentStep,
      showLongDisclaimer: (state: any) => state.showLongDisclaimer,
    }),
    UtilityHelper() {
      return UtilityHelper;
    },
  },
  components: {
    HowToTakePicture,
    File,
    SubmitButton,
    NavigationButton,
    UploadError,
    DesktopUpload,
    SecurityPopup,
  },
});
